import MuiPopover, { PopoverProps } from '@mui/material/Popover';

interface CustomProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

type Props = Omit<PopoverProps, 'open'> & CustomProps;

export const Popover = ({ children, anchorEl, ...props }: Props) => {
  const isOpen = Boolean(anchorEl);
  const id = isOpen ? 'simple-popover' : undefined;

  return (
    <MuiPopover
      open={isOpen}
      id={id}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      PaperProps={{ sx: { borderRadius: 4, color: 'red' } }}
      {...props}
    >
      {children}
    </MuiPopover>
  );
};
